export const OrganisationDetailsTabs = {
  LOCATIONS: 'Locations',
  ORG_MAP: 'Organization',
};

export const OrganisationDetailsData = {
  TITLE: 'Organization Details',
  ORGANIZATION_SIZE: 'Organization size',
  SECTOR: 'Sector',
  COMPANY_TYPE: 'Company Type',
  ORGANIZATION_BOUNDARY: 'Organizational Boundary',
};

export const ReportingDetailsData = {
  TITLE: 'Reporting Details',
  REPORTING_YEAR: 'Start of your reporting year',
  BASELINE_YEAR: 'Baseline year',
  BASELINE_YEAR_RECALCULATION_THRESHOLD:
    'Baseline year Recalculation Threshold',
};

export const OrganisationDetailsEnum = {
  DASHBOARD_BUTTON: 'Dashboard',
  ADD_LOCATION: 'Add Location',
  YEAR: 'Year',
  SEARCH: 'search',
  SORT_BY: 'sortBy',
  SORT_DIR: 'sortDir',
  PAGE: 'page',
  YEAR_PARAM: 'year',
  DELETE_MODAL_TITLE: 'Are you sure you want to delete the organization?',
};

export const LocationParams = [
  OrganisationDetailsEnum.SORT_BY,
  OrganisationDetailsEnum.SORT_DIR,
  OrganisationDetailsEnum.SEARCH,
  OrganisationDetailsEnum.PAGE,
  OrganisationDetailsEnum.YEAR_PARAM,
];

export const deleteStepsInfo = [
  `Deleting the organization will remove it entirely across all years, along with any associated locations under it.`,
  `Deleting this organization will cause all its child organizations, across all years, to be automatically linked to the next parent organization.`,
];
